import { TEMPLATES } from "../routes/RouteCreateRequirementByTemplate/templates";
import { RequirementDefinitionTemplate } from "../routes/RouteCreateRequirementByTemplate/types";

export function getRequirementDefinitionTemplateByKey(
  key: string
): RequirementDefinitionTemplate {
  return TEMPLATES.find(template => template.key === key)!;
}
